import { useState } from 'react'
import VideoCard from './components/VideoCard'
import NodataYet from '../../../Components/NodataYet'
import { Spinner } from 'react-bootstrap'
import { useHowToVideos } from '../../../hooks/useHowToVideos'
import { SearchFilters } from './components/SearchFilter'
import { HowToVideo } from '../../../../services/cellcast.type'
import VideoDetail from './components/VideoDetail'
import { getVideoThumbnail } from '../../../Utils/videoUtils'
import { useNavigate } from 'react-router-dom'

const HowToVideosPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  //const [searchTerm, setSearchTerm] = useState('');
  const [selectedVideo, setSelectedVideo] = useState<HowToVideo | null>(null);

  const navigate = useNavigate()

  // Use custom hook for video management
  const {
    videos,
    isLoading,
    totalVideos,
    currentPage,
    setCurrentPage,
    searchTerm,
    setSearchTerm,
    totalPages
  } = useHowToVideos({
    pageSize: 10,
    category: selectedCategory === 'All' ? undefined : selectedCategory
  });

const categories = {
  'getting-started': 'Getting Started',
  'messaging': 'Messaging',
  'automation': 'Automation',
  'contacts': 'Contacts',
  'reports': 'Reports',
  'integrations': 'Integrations',
  'advanced': 'Advanced'
};
  // Generate category and article options from videos
  const categoryOptions = ['All', ...Object.keys(categories)];

  // Instant search onChange
  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  // Category change
  const handleCategoryChange = (cat: string) => {
    setSelectedCategory(cat);
    setCurrentPage(1);
  };

  // Clear filters
  const handleClearFilters = () => {
    setSelectedCategory('All');
    setSearchTerm('');
    setCurrentPage(1);
  };

  // Back to main list
  const handleBack = () => {
    setSelectedVideo(null);
  };

  // Breadcrumb click
  const handleBreadcrumbCategory = () => {
    setSelectedVideo(null);
    setSelectedCategory(selectedVideo?.category || 'All');
    setCurrentPage(1);
  };

  return (
    <>
    <div className="card">
      <div className="container">
          <div className='pace-y-6 background-white'>
          <div>
            <h1 className="mb-2 mt-4">How To Videos</h1>
            <p className="text-muted-foreground">
              Check out our how-to videos — all sorted by category to help you find what you need fast!
            </p>
          </div>
          {!selectedVideo && (
            <div className='relative'>
              <SearchFilters
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
                selectedCategory={selectedCategory}
                onCategoryChange={handleCategoryChange}
                onClearFilters={handleClearFilters}
                categories={categoryOptions}
              />
            </div>
          )}
        </div>

      {/* Video detail view using VideoDetail component */}
      {selectedVideo ? (
        <VideoDetail
          imagePath={getVideoThumbnail(selectedVideo) }
          title={selectedVideo.title}
          description={selectedVideo.description}
          footerText={''}
          category={selectedVideo.category || ''}
          article={selectedVideo.subTitle || ''}
          item={selectedVideo}
          onBackToList={handleBack}
          onCategoryClick={handleBreadcrumbCategory}
        />
      ) : (
        <>
          <div className="flex items-center justify-between">
            <p className="text-muted-foreground mt-3">
              {videos.length} video{videos.length !== 1 ? 's' : ''} found
            </p>
          </div>
          {isLoading ? <div className='text-center mt-10'><Spinner /></div> : null}
          {!isLoading && videos.length === 0 ? <NodataYet message='No recent videos (yet!)' /> : null}
          {(!isLoading && videos.length > 0) && (
            <div className='row gy-8 gx-4'>
              {videos.map((item, index) => (
                <div className='col-md-4 d-flex' key={item._id || index}>
                  <VideoCard
                    item={item}
                    onClick={() => navigate('/help/how-to-videos/' + item._id)}
                  />
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          {!isLoading && videos.length > 0 && totalPages > 1 && (
            <div className='d-flex justify-content-center mt-8'>
              <nav>
                <ul className='pagination'>
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button
                      className='page-link'
                      onClick={() => setCurrentPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                  </li>

                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum: number;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    return (
                      <li key={pageNum} className={`page-item ${currentPage === pageNum ? 'active' : ''}`}>
                        <button
                          className='page-link'
                          onClick={() => setCurrentPage(pageNum)}
                        >
                          {pageNum}
                        </button>
                      </li>
                    );
                  })}

                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button
                      className='page-link'
                      onClick={() => setCurrentPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}

          {/* Results info */}
          {!isLoading && videos.length > 0 && (
            <div className='text-center mt-4 text-muted'>
              Showing {videos.length} of {totalVideos} videos
            </div>
          )}
        </>
      )}
      </div>
    </div>
 
    </>
  );
};

export default HowToVideosPage